import React, { useState } from 'react';

const FAQ = () => {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (index) => {
    setOpenItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const faqData = [
    {
      category: "General Questions",
      questions: [
        {
          question: "What is RiseWithilly?",
          answer: "RiseWithilly is an online education platform specializing in communication skills training. We offer comprehensive courses in public speaking, interpersonal communication, digital communication, and leadership communication to help individuals and professionals improve their ability to connect and communicate effectively."
        },
        {
          question: "Who are your courses designed for?",
          answer: "Our courses are designed for anyone looking to improve their communication skills, including professionals, students, entrepreneurs, educators, and anyone who wants to build confidence in speaking and connecting with others. We offer courses for all skill levels, from beginners to advanced learners."
        },
        {
          question: "Do I need any prior experience to take your courses?",
          answer: "No prior experience is required! Our courses are designed to accommodate learners of all levels. We provide clear learning paths and foundational concepts, making our content accessible to beginners while also offering advanced techniques for more experienced learners."
        },
        {
          question: "How long do I have access to the courses?",
          answer: "You have lifetime access to all course materials once you purchase a course. This means you can revisit the content anytime, anywhere, and continue learning at your own pace without any time restrictions."
        }
      ]
    },
    {
      category: "Course Content & Structure",
      questions: [
        {
          question: "What types of courses do you offer?",
          answer: "We offer courses in public speaking, presentation skills, interpersonal communication, digital communication, leadership communication, negotiation skills, and conflict resolution. Each course includes video lessons, practical exercises, downloadable resources, and interactive assessments."
        },
        {
          question: "How are the courses structured?",
          answer: "Our courses are structured in modules with clear learning objectives. Each module contains video lessons, reading materials, practical exercises, and quizzes. Courses typically range from 4-12 modules, with each module taking 30-60 minutes to complete."
        },
        {
          question: "Can I download course materials?",
          answer: "Course materials are available for online viewing only to protect intellectual property rights. However, you can access all materials anytime through your account dashboard. Some courses include downloadable worksheets and templates that you can save for personal use."
        },
        {
          question: "Are there any prerequisites for specific courses?",
          answer: "Most courses don't have prerequisites, but we recommend starting with foundational courses if you're new to communication training. Some advanced courses may suggest completing basic courses first, but this is clearly indicated in the course description."
        }
      ]
    },
    {
      category: "Certificates & Completion",
      questions: [
        {
          question: "Do I get a certificate upon completion?",
          answer: "Yes! Upon successful completion of all course modules and assessments, you will receive a certificate of completion. This certificate can be downloaded and shared on your LinkedIn profile or resume to showcase your communication skills development."
        },
        {
          question: "What is required to receive a certificate?",
          answer: "To receive a certificate, you must complete all course modules, pass the final assessment with a score of 70% or higher, and complete any required practical exercises. The certificate will be automatically generated and available in your account dashboard."
        },
        {
          question: "Are your certificates recognized by employers?",
          answer: "While our certificates demonstrate your commitment to professional development and communication skills improvement, they are not accredited degrees. However, many employers value the practical skills and knowledge gained from our courses, and the certificates can enhance your professional profile."
        },
        {
          question: "Can I retake assessments if I don't pass?",
          answer: "Yes, you can retake assessments up to 3 times. We encourage learning from mistakes and provide detailed feedback to help you improve. If you need additional attempts, please contact our support team."
        }
      ]
    },
    {
      category: "Technical Support",
      questions: [
        {
          question: "What devices can I use to access courses?",
          answer: "Our platform is compatible with desktop computers, laptops, tablets, and smartphones. You can access your courses through any modern web browser. We also have mobile-optimized interfaces for the best learning experience on mobile devices."
        },
        {
          question: "What if I experience technical difficulties?",
          answer: "If you encounter technical issues, please contact our support team at karabacakhilal1.1@gmail.com. We typically respond within 24 hours and will work with you to resolve any problems. Common issues include browser compatibility, internet connectivity, and account access problems."
        },
        {
          question: "Do I need special software to take courses?",
          answer: "No special software is required! All courses are delivered through our web-based platform. You only need a modern web browser (Chrome, Firefox, Safari, or Edge) and a stable internet connection. Some courses may include optional downloadable resources."
        },
        {
          question: "Can I access courses offline?",
          answer: "Currently, our courses require an internet connection to access. We're working on offline capabilities for future updates. However, you can download certain resources and worksheets for offline reference."
        }
      ]
    },
    {
      category: "Pricing & Payment",
      questions: [
        {
          question: "How much do your courses cost?",
          answer: "Course prices vary depending on the content and duration. Individual courses typically range from $99 to $299. We also offer bundle packages and seasonal discounts. Check our courses page for current pricing and special offers."
        },
        {
          question: "What payment methods do you accept?",
          answer: "We accept all major credit cards (Visa, MasterCard, American Express), PayPal, and bank transfers. All payments are processed securely through our encrypted payment system to protect your financial information."
        },
        {
          question: "Do you offer payment plans?",
          answer: "Yes, we offer flexible payment plans for select courses. You can split your payment into 2-3 installments over 2-3 months. Payment plan options are available at checkout for eligible courses."
        },
        {
          question: "Are there any hidden fees?",
          answer: "No hidden fees! The price you see is the price you pay. There are no additional charges for certificates, support, or course updates. All taxes are included in the displayed price."
        }
      ]
    },
    {
      category: "Refunds & Guarantees",
      questions: [
        {
          question: "What is your refund policy?",
          answer: "We offer a 30-day money-back guarantee for all courses. If you're not satisfied with your purchase, you can request a full refund within 30 days of purchase, provided you haven't completed more than 50% of the course content."
        },
        {
          question: "How do I request a refund?",
          answer: "To request a refund, contact our support team at karabacakhilal1.1@gmail.com with your order details and reason for the refund request. We'll review your request and process approved refunds within 5-7 business days."
        },
        {
          question: "What if I'm not satisfied with the course quality?",
          answer: "We're committed to providing high-quality content. If you're not satisfied with the course quality, please contact our support team. We'll work with you to address your concerns and may offer additional resources or a refund if appropriate."
        },
        {
          question: "Can I get a refund if I change my mind?",
          answer: "Yes, you can request a refund within the first 7 days of purchase for any reason, no questions asked. After 7 days, refunds are subject to our standard refund policy conditions."
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Find answers to common questions about our courses, platform, and services.
          </p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {faqData.map((category, categoryIndex) => (
          <div key={categoryIndex} className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-8">{category.category}</h2>
            <div className="space-y-4">
              {category.questions.map((item, itemIndex) => {
                const globalIndex = `${categoryIndex}-${itemIndex}`;
                const isOpen = openItems[globalIndex];
                
                return (
                  <div key={itemIndex} className="bg-white rounded-lg shadow-md">
                    <button
                      onClick={() => toggleItem(globalIndex)}
                      className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors"
                    >
                      <span className="font-semibold text-gray-900">{item.question}</span>
                      <svg
                        className={`w-5 h-5 text-gray-500 transform transition-transform ${isOpen ? 'rotate-180' : ''}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                    {isOpen && (
                      <div className="px-6 pb-4">
                        <p className="text-gray-700 leading-relaxed">{item.answer}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}

        {/* Contact Section */}
        <div className="bg-white rounded-xl shadow-lg p-8 mt-16">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">Still Have Questions?</h2>
          <p className="text-gray-700 text-center mb-8">
            Can't find the answer you're looking for? Our support team is here to help!
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-gray-50 rounded-lg p-6 text-center">
              <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Email Support</h3>
              <p className="text-gray-600 mb-2">karabacakhilal1.1@gmail.com</p>
              <p className="text-sm text-gray-500">Response within 24 hours</p>
            </div>
            <div className="bg-gray-50 rounded-lg p-6 text-center">
              <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Phone Support</h3>
              <p className="text-sm text-gray-500">Mon-Fri 9AM-6PM EST</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
